export const isStrongPassword = (value: string) => {
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!]).{8,}$/;
  return passwordRegex.test(value);
};
